export default __webpack_public_path__ + "static/media/sprite.8ae15150.svg";